import Vue from 'vue'
import Grid from '@/components/DynamicComponents/Projects/NewConstruction/Grid'
import { formatCurrency } from '@/services/convert'
import { costTypes } from '@/services/config'

export default {
  components: {
    'ag-grid-vue': Grid,
  },
  props: [
    'costDetails',
    'type',
    'dropdownData',
    'screenIndentifier',
    'sequence',
    'tiles',
    'levelTiles',
    'childTiles',
    'isArchive',
  ],
  data() {
    return {
      columnDefs: [],
      loader: true,
      allPannels: [],
      create: new Vue(),
      height: '30rem',
      list: [],
      formatCurrency: formatCurrency,
      visible: false,
      loading: false,
      levelIndex: 0,
      editLevel: false,
      loaderText: false,
      isUpdate: false,
      tileTotal: 0,
      adjustmentTileTotal: 0,
      parentTotal: 0,
      width: '110rem',
      padding: '0px',
      isValidTakeoff: true,
    }
  },
  beforeMount() {
    this.loadingConfig()
    window.addEventListener('resize', this.detectViewPortListener)
  },
  created() {
    this.visible = true
    this.tileTotal = this.costDetails.takeoffs
      .filter(i => !i.isAdjustmentTakeoff)
      .reduce((total, takeoff) => {
        return total + (takeoff.unitCost ? takeoff.unitCost : 0)
      }, 0)
    this.adjustmentTileTotal = this.costDetails.takeoffs
      .filter(i => i.isAdjustmentTakeoff)
      .reduce((total, takeoff) => {
        return total + (takeoff.unitCost ? takeoff.unitCost : 0)
      }, 0)
    this.isValidTakeoff = this.costDetails.isValidTakeoff
  },
  mounted() {
    // this.$root.$on('addLevel', this.addLevel)
  },
  beforeDestroy() {
    // this.$root.$off('addLevel')
  },
  methods: {
    loadingConfig() {
      this.columnDefs = [
        {
          rowDrag: true,
          headerName: '',
          field: 'display',
          floatingFilter: false,
          width: 3,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          sortable: false,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: '',
          field: 'isValidTakeoff',
          floatingFilter: false,
          width: 3,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          sortable: false,
          pinned: 'left',
          menuTabs: [],
          cellRenderer: 'actionCellRenderer',
          cellRendererParams: {
            name: 'validTakeoff',
          },
        },
        {
          field: 'checkbox',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          filter: false,
          editable: false,
          width: 5,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: 'ID',
          field: 'id',
          headerTooltip: 'ID',
          width: 60,
          wrapText: false,
          editable: false,
          filter: 'customFilter',
          cellRendererParams: {
            searchType: 'string',
          },
          resizable: true,
          cellStyle: { textAlign: 'left' },
          headerClass: 'header-left',
        },
        {
          headerName: 'Cost Type',
          field: 'costType',
          headerTooltip: 'Cost Type',
          cellEditor: 'selectEditor',
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'actualCostLevel',
            dropdownName: 'costType',
            dropdownData: this.dropdownData,
          },
          width: 150,
          wrapText: false,
          editable: !this.isArchive,
          filter: 'customFilter',
          resizable: true,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Contract',
          field: 'contract',
          headerTooltip: 'Contract',
          cellEditor: 'selectEditor',
          cellRendererParams: {
            type: 'actualCostLevel',
            dropdownName: 'contract',
            dropdownData: this.dropdownData,
            name: 'newContract',
          },
          width: 150,
          wrapText: false,
          filter: 'customFilter',
          editable: params => {
            return !costTypes.includes(params.data.mCostTypeId) && !this.isArchive
          },
          resizable: true,
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Cat Code',
          field: 'categoryCode',
          headerTooltip: 'Cat Code',
          cellEditor: 'selectEditor',
          cellRendererParams: {
            type: 'actualCostLevel',
            dropdownName: 'category',
            dropdownData: this.dropdownData,
          },
          width: 150,
          wrapText: false,
          editable: params => {
            return !costTypes.includes(params.data.mCostTypeId) && !this.isArchive
          },
          filter: 'customFilter',
          resizable: true,
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Description',
          field: 'takeoff',
          headerTooltip: 'Description',
          cellEditor: 'textEditor',
          cellRendererParams: {
            type: 'actualCostLevel',
            name: 'takeoff_Name',
            screen: 'Project',
            maxLength: 100,
          },
          width: 200,
          wrapText: false,
          filter: 'customFilter',
          resizable: true,
          editable: !this.isArchive,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Cost',
          field: 'unitCost',
          headerTooltip: 'Cost',
          cellEditor: 'inputNumberEditor',
          cellRenderer: 'costPriceCellRenderer',
          headerClass: 'header-right',
          cellRendererParams: {
            type: 'actualCostLevel',
            placeholder: 'Cost',
            precision: 2,
          },
          width: 100,
          wrapText: false,
          editable: params => {
            return !params.data.isAdjustmentTakeoff && !this.isArchive
          },
          filter: 'customFilter',
          resizable: true,
        },
        {
          headerName: 'Note',
          field: 'note',
          headerTooltip: 'Note',
          width: 200,
          wrapText: false,
          editable: !this.isArchive,
          filter: 'customFilter',
          cellEditor: 'textEditor',
          cellRendererParams: {
            type: 'actualCostLevel',
            placeholder: 'Note',
          },
          resizable: true,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Child Tile Name',
          field: 'tileName',
          headerTooltip: 'Child Tile Name',
          cellEditor: 'selectEditor',
          cellRendererParams: {
            type: 'actualCostLevel',
            dropdownName: 'tile',
            name: 'tile',
            dropdownData: Object.assign(this.dropdownData, { tile: this.tiles }),
          },
          width: 150,
          wrapText: false,
          resizable: true,
          editable: params => {
            return !params.data.isAdjustmentTakeoff && !this.isArchive
          },
          hide: this.costDetails.isAdjustmentTile,
          cellRenderer: 'toolTipRenderer',
          filter: 'customFilter',
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          cellRenderer: 'actionCellRenderer',
          cellRendererParams: {
            type: 'actualCost',
          },
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          floatingFilter: false,
          width: 80,
          resizable: false,
          suppressSizeToFit: true,
          headerTooltip: 'Action',
          pinned: 'right',
          menuTabs: [],
        },
      ]
    },

    handleOk() {},

    onUpdate(flag) {
      this.isUpdate = flag
    },

    handleCancel() {
      this.visible = false
      this.$emit('closeTakeoff', false, this.isUpdate)
    },

    calculateTileTotal(takeoffs) {
      this.tileTotal = takeoffs
        .filter(i => !i.isAdjustmentTakeoff)
        .reduce((total, takeoff) => {
          return total + (takeoff.unitCost ? takeoff.unitCost : 0)
        }, 0)

      this.adjustmentTileTotal = takeoffs
        .filter(i => i.isAdjustmentTakeoff)
        .reduce((total, takeoff) => {
          return total + (takeoff.unitCost ? takeoff.unitCost : 0)
        }, 0)

      this.isValidTakeoff = !takeoffs.some(
        i =>
          !i.isAdjustmentTakeoff &&
          typeof i.isValidTakeoff !== 'undefined' &&
          !i.isValidTakeoff,
      )
    },

    detectViewPortListener() {
      if (window.innerWidth > 1450) {
        this.width = '110rem'
        this.padding = '0px !important'
      } else if (window.innerWidth < 1450) {
        this.width = '100%'
        this.padding = '10px !important'
      } else {
        this.width = '110rem'
        this.padding = '0px !important'
      }
    },

    reloadLevels() {
      this.$emit('reloadLevels')
    },

    showHighlightTab(flag) {
      this.isValidTakeoff = flag
    },
  },
}
